import { promiseActionFactory } from "@teroneko/redux-saga-promise";

import { createActionTypes } from "utils/store";
import {
  ICreateCPRecommendation,
  ICreateRecommendation,
  IServiceItem,
  IServiceParams,
  IUploadIcon,
  IRecommendation,
  ICPRecommendation,
  IFormOfferRecommendation,
  IOfferRecommendation,
  IEditRecommendation,
  IEditCPRecommendation,
} from "types/recommendations.types";
import { LoadListDataParams, LoadListDataResponse } from "hooks/useListData";

const RECOMMENDATIONS_ACTIONS = {
  LOAD_RECOMMENDATIONS: 'LOAD_RECOMMENDATIONS',
  CREATE_RECOMMENDATION: 'CREATE_RECOMMENDATION',
  DELETE_RECOMMENDATION: 'DELETE_RECOMMENDATION',
  EDIT_RECOMMENDATION: 'EDIT_RECOMMENDATION',
  LOAD_SERVICES: 'LOAD_SERVICES',
  LOAD_COMPLEX_PROGRAM_RECOMMENDATIONS: 'LOAD_COMPLEX_PROGRAM_RECOMMENDATIONS',
  CREATE_COMPLEX_PROGRAM_RECOMMENDATION: 'CREATE_COMPLEX_PROGRAM_RECOMMENDATION',
  DELETE_COMPLEX_PROGRAM_RECOMMENDATION: 'DELETE_COMPLEX_PROGRAM_RECOMMENDATION',
  EDIT_COMPLEX_PROGRAM_RECOMMENDATION: 'EDIT_COMPLEX_PROGRAM_RECOMMENDATION',
  UPLOAD_ICON: 'UPLOAD_ICON',
  CREATE_OFFER_RECOMMENDATION: 'CREATE_OFFER_RECOMMENDATION',
  LOAD_OFFER_RECOMMENDATIONS: 'LOAD_OFFER_RECOMMENDATIONS',
  DELETE_OFFER_RECOMMENDATION: 'DELETE_OFFER_RECOMMENDATION',
  EDIT_OFFER_RECOMMENDATION: 'EDIT_OFFER_RECOMMENDATION',
};

const actionTypes = createActionTypes('recommendations', RECOMMENDATIONS_ACTIONS);

export const loadRecommendationsAction = promiseActionFactory<LoadListDataResponse<IRecommendation>>().create<LoadListDataParams>(actionTypes.LOAD_RECOMMENDATIONS);
export const createRecommendationAction = promiseActionFactory().create<ICreateRecommendation>(actionTypes.CREATE_RECOMMENDATION);
export const deleteRecommendationAction = promiseActionFactory().create<{ id: number }>(actionTypes.DELETE_RECOMMENDATION);
export const editRecommendationAction = promiseActionFactory().create<{ id: number, values: IEditRecommendation}>(actionTypes.EDIT_RECOMMENDATION);
export const loadServicesAction = promiseActionFactory<LoadListDataResponse<IServiceItem>>().create<LoadListDataParams<IServiceParams>>(actionTypes.LOAD_SERVICES);
export const loadCPRecommendationsAction = promiseActionFactory<LoadListDataResponse<ICPRecommendation>>().create<LoadListDataParams>(actionTypes.LOAD_COMPLEX_PROGRAM_RECOMMENDATIONS);
export const createCPRecommendationAction = promiseActionFactory().create<ICreateCPRecommendation>(actionTypes.CREATE_COMPLEX_PROGRAM_RECOMMENDATION);
export const deleteCPRecommendationAction = promiseActionFactory().create<{ id: number }>(actionTypes.DELETE_COMPLEX_PROGRAM_RECOMMENDATION);
export const editCPRecommendationAction = promiseActionFactory().create<{ id: number, values: IEditCPRecommendation}>(actionTypes.EDIT_COMPLEX_PROGRAM_RECOMMENDATION);
export const uploadIconAction = promiseActionFactory<IUploadIcon>().create<{ file: Blob }>(actionTypes.UPLOAD_ICON);
export const createOfferRecommendationAction = promiseActionFactory().create<IFormOfferRecommendation>(actionTypes.CREATE_OFFER_RECOMMENDATION);
export const loadOfferRecommendationsAction = promiseActionFactory<LoadListDataResponse<IOfferRecommendation>>().create<LoadListDataParams>(actionTypes.LOAD_OFFER_RECOMMENDATIONS);
export const deleteOfferRecommendationAction = promiseActionFactory().create<{ id: number }>(actionTypes.DELETE_OFFER_RECOMMENDATION);
export const editOfferRecommendationAction = promiseActionFactory().create<{ id: number, values: IFormOfferRecommendation}>(actionTypes.EDIT_OFFER_RECOMMENDATION);
